// import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { getLocale } from "react-i18nify";

import font from "src/styles/font";
import { checkNotEmpty } from "src/common";

import {
  TextField,
  Grid,
  Box,
  Autocomplete,
  FormControlLabel,
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

import Tooltip from "src/components/upload/Tooltip";
import { MainSwitch as Switch } from "src/components/core/Switch";

import { UseUpload } from "src/context/UploadProductContext";
import { useAuth } from "src/hooks/useAuth";

const WrapperContainer = styled.div`
  width: 100%;
  background-color: var(--darkwhite-color);
  border-radius: 16px;
  padding: 32px;
  padding-bottom: 40px;
`;

const SpanTitle = styled.div`
  font-size: ${font.size.lg};
  color: var(--darkgrey-color);
  font-weight: 600;
`;

const WrapperButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: max-content;

  .Button-Add {
    color: #ffffff;
    width: max-content;
    background: #e04132;
    box-shadow:
      0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14),
      0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    height: 52px;
    padding: 16px 24px;
  }
  .Button-Add:focus {
    background-color: #e04132;
  }
  .Button-Add:hover {
    background-color: #e04132;
    opacity: 0.9;
  }
`;

const WrapperTextfield = styled.div`
  /* width: ${({ half }) => (half ? "48.5%" : "100%")}; */
  width: 100%;

  ${({ divTool }) =>
    divTool &&
    css`
      display: flex;
      gap: 10px;
    `}

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 16px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiAutocomplete-root {
    /* margin: ${({ item }) => (item ? "0" : "24px 0")}; */
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    border-radius: 16px;
    padding: 16px;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
  }

  .MuiTextField-root {
    border-radius: 16px;
  }
  .MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiAutocomplete-root .MuiOutlinedInput-root {
    padding-left: 16px;
  }
  .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
    padding: 7.5px 0;
  }
`;

const SpanSubTitle = styled(Box)`
  font-size: ${font.size.md};
  color: var(--secondary-color);
  font-weight: 400;
`;

const MiddleLine = styled.div`
  width: 5px;
  /* height: 350px; */
  height: calc(100% - 60px);
  max-height: 350px;
  /* min-height: 310px; */
  margin: 60px 35px auto;
  background-color: var(--white-color);
  border-radius: 2px;
`;

const WarningText = styled(Box)`
  width: 100%;
  /* margin-top: 12px; */
  display: flex;
  gap: 8px;

  span {
    padding-top: 3px;
    font-size: ${font.size.xs};
    color: var(--darkgrey-color);
  }
`;

const UnitPriceGrid = ({ choiceIndex }) => {
  const { user, checkAllowPermission } = useAuth();

  const { masterdata, dataUploadChoice, onChangeUpload, choiceErrors } =
    UseUpload();

  return (
    <WrapperContainer>
      <SpanTitle>Calculation</SpanTitle>

      <Grid
        container
        spacing={0}
        sx={{
          m: 0,
          width: "100%",
        }}
      >
        {/* left */}
        <Grid
          item
          xs={6.5}
          sx={{
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          <Grid
            container
            spacing={0}
            rowSpacing={4}
            columnSpacing={2.5}
            sx={{
              m: 0,
              ml: -2.5,
              ".MuiFormHelperText-root": {
                position: "absolute",
                bottom: "-20px",
                mr: 0,
              },
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                "&.MuiGrid-item": {
                  paddingTop: 2,
                },
              }}
            >
              <WrapperButton>
                <FormControlLabel
                  label="ราคาเริ่มต้น"
                  sx={{
                    ".MuiFormControlLabel-label": {
                      ml: 1,
                      fontSize: font.size.md,
                    },
                  }}
                  control={
                    <Switch
                      sx={{ m: 1 }}
                      checked={
                        dataUploadChoice[choiceIndex]?.group_price
                          ?.is_start_price
                      }
                      onChange={(e) => {
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.group_price.is_start_price`,
                          e.target.checked,
                        );
                      }}
                    />
                  }
                />
              </WrapperButton>

              <WarningText sx={{ mt: "14px" }}>
                <ErrorIcon sx={{ color: "var(--gold-color)" }} />

                <span>
                  หากเลือกเป็นราคาเริ่มต้น
                  สินค้าของคุณจะไม่สามารถซื้อขายผ่านหน้าเว็บได้
                  การซื้อขายนั้นจะกลายเป็นติดต่อผ่านไลน์เท่านั้น
                </span>
              </WarningText>
            </Grid>

            <Grid
              item
              xs={6}
              sx={{
                "&.MuiGrid-item": {
                  paddingTop: 2,
                },
              }}
            >
              <WrapperTextfield className="form-input">
                {dataUploadChoice[choiceIndex]?.group_price?.is_start_price ? (
                  <TextField
                    label="ราคาเริ่มต้นที่"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{
                      shrink: checkNotEmpty(
                        dataUploadChoice[choiceIndex]?.group_price?.start_price,
                      )
                        ? true
                        : false,
                    }}
                    value={
                      dataUploadChoice[choiceIndex]?.group_price.start_price
                    }
                    onChange={(e) => {
                      if (e.target.value * 0 === 0)
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.group_price.start_price`,
                          e.target.value,
                        );
                    }}
                    onBlur={(e) => {
                      if (e.target.value * 0 === 0)
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.group_price.start_price`,
                          parseFloat(e.target.value) || null,
                        );
                    }}
                    error={
                      !!choiceErrors[
                        `choices[${choiceIndex}].group_price.start_price`
                      ]
                    }
                    helperText={
                      !!choiceErrors[
                        `choices[${choiceIndex}].group_price.start_price`
                      ]
                        ? "โปรดระบุราคาเริ่มต้น"
                        : ""
                    }
                  />
                ) : (
                  <TextField
                    label="ราคาขาย"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{
                      shrink: checkNotEmpty(
                        dataUploadChoice[choiceIndex]?.group_price?.price,
                      )
                        ? true
                        : false,
                    }}
                    value={dataUploadChoice[choiceIndex]?.group_price.price}
                    onChange={(e) => {
                      if (e.target.value * 0 === 0)
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.group_price.price`,
                          e.target.value,
                        );
                    }}
                    onBlur={(e) => {
                      if (e.target.value * 0 === 0)
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.group_price.price`,
                          parseFloat(e.target.value) || null,
                        );
                    }}
                    error={
                      !!choiceErrors[
                        `choices[${choiceIndex}].group_price.price`
                      ]
                    }
                    helperText={
                      !!choiceErrors[
                        `choices[${choiceIndex}].group_price.price`
                      ]
                        ? "โปรดระบุราคา"
                        : ""
                    }
                  />
                )}
              </WrapperTextfield>
            </Grid>

            <Grid
              item
              xs={6}
              sx={{
                "&.MuiGrid-item": {
                  paddingTop: 2,
                },
              }}
            >
              <WrapperTextfield className="form-input">
                <Autocomplete
                  disablePortal
                  blurOnSelect
                  id="select-unit-price"
                  isOptionEqualToValue={(option, value) =>
                    option?._id === value?._id
                  }
                  options={masterdata?.unitPrice_data}
                  sx={{
                    ".MuiOutlinedInput-input": {
                      borderRadius: 0,
                    },
                  }}
                  value={dataUploadChoice[choiceIndex]?.group_price?.unit_price}
                  onChange={(e, newValue) => {
                    onChangeUpload(
                      null,
                      `choices.${choiceIndex}.group_price.unit_price`,
                      newValue,
                    );
                    // handleQuatityByUnitPrice(newValue);
                  }}
                  getOptionLabel={(option) => {
                    return getLocale() === "th"
                      ? option.unit_th
                      : option.unit_en;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="หน่วยราคา"
                      error={
                        !!choiceErrors[
                          `choices[${choiceIndex}].group_price.unit_price`
                        ]
                      }
                      helperText={
                        !!choiceErrors[
                          `choices[${choiceIndex}].group_price.unit_price`
                        ]
                          ? "โปรดเลือกหน่วยราคา"
                          : ""
                      }
                    />
                  )}
                />
              </WrapperTextfield>
            </Grid>

            {user?.role_id === 1 ? (
              <Grid item xs={12}>
                <WrapperTextfield>
                  <TextField
                    label="ราคาพิเศษ"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{
                      shrink: checkNotEmpty(
                        dataUploadChoice[choiceIndex]?.group_price
                          ?.special_price,
                      )
                        ? true
                        : false,
                    }}
                    value={
                      dataUploadChoice[choiceIndex]?.group_price?.special_price
                    }
                    onChange={(e) => {
                      if (e.target.value * 0 === 0)
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.group_price.special_price`,
                          e.target.value,
                        );
                    }}
                  />
                </WrapperTextfield>
              </Grid>
            ) : null}

            {user?.role_id === 1 &&
            checkAllowPermission("products.can_view_costPrice") ? (
              <Grid item xs={12}>
                <WrapperTextfield>
                  <TextField
                    label="ราคาต้นทุน"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{
                      shrink: checkNotEmpty(
                        dataUploadChoice[choiceIndex]?.group_price?.cost_price,
                      )
                        ? true
                        : false,
                    }}
                    value={
                      dataUploadChoice[choiceIndex]?.group_price?.cost_price
                    }
                    onChange={(e) => {
                      if (e.target.value * 0 === 0)
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.group_price.cost_price`,
                          e.target.value,
                        );
                    }}
                  />
                </WrapperTextfield>
              </Grid>
            ) : null}

            {/* Condition */}
            {/* unit !== 'หน่วย' || 'ตร.ม.' || 'อัน || 'ถัง' || 'กิโลกรัม' || ' ชุด' || 'ลิตร' */}
            {dataUploadChoice[choiceIndex]?.group_price?.unit_price?._id !==
              "63c90d859d945fef0df81f5f" && // ตร.ม.
              dataUploadChoice[choiceIndex]?.group_price?.unit_price?._id !==
                "6480441071bbd9b8584b7008" && // อัน
              dataUploadChoice[choiceIndex]?.group_price?.unit_price?._id !==
                "69bba6a0ca2c69fc3472fbbf" && // คู่
              dataUploadChoice[choiceIndex]?.group_price?.unit_price?._id !==
                "63c90d859d945fef0df81f62" && // หน่วย
              dataUploadChoice[choiceIndex]?.group_price?.unit_price?._id !==
                "63c90d859d945fef0df81f6a" && // เมตร
              dataUploadChoice[choiceIndex]?.group_price?.unit_price?._id !==
                "63c90d859d945fef0df81f60" && // ถัง
              dataUploadChoice[choiceIndex]?.group_price?.unit_price?._id !==
                "63c90d859d945fef0df81f66" && // ชุด
              dataUploadChoice[choiceIndex]?.group_price?.unit_price?._id !==
                "63c90d859d945fef0df81f64" && ( // ลิตร
                <>
                  {/* ราคา/ตร.ม. (group_price.price_per_sq) */}
                  {dataUploadChoice[choiceIndex]?.group_price?.unit_price
                    ?._id !== "69bba665ca2c69fc3472fbbe" && (
                    <Grid item xs={12}>
                      <WrapperTextfield className="form-input">
                        <TextField
                          label="ราคา/ตร.ม"
                          variant="outlined"
                          fullWidth
                          InputLabelProps={{
                            shrink: checkNotEmpty(
                              dataUploadChoice[choiceIndex]?.group_price
                                ?.price_per_sq,
                            )
                              ? true
                              : false,
                          }}
                          value={
                            dataUploadChoice[choiceIndex].group_price
                              .price_per_sq
                          }
                          onChange={(e) => {
                            if (e.target.value * 0 === 0)
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.group_price.price_per_sq`,
                                e.target.value,
                              );
                          }}
                          onBlur={(e) => {
                            if (e.target.value * 0 === 0)
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.group_price.price_per_sq`,
                                parseFloat(e.target.value) || null,
                              );
                          }}
                          // error={
                          //   !!choiceErrors[
                          //     `choices[${choiceIndex}].group_price.price_per_sq`
                          //   ]
                          // }
                          // helperText={
                          //   !!choiceErrors[
                          //     `choices[${choiceIndex}].group_price.price_per_sq`
                          //   ]
                          //     ? "โปรดระบุราคาต่อ ตรม."
                          //     : ""
                          // }
                        />
                      </WrapperTextfield>
                    </Grid>
                  )}

                  {/* จำนวน/หน่วย (size.sale_unit) */}
                  {(dataUploadChoice[choiceIndex]?.group_price?.unit_price
                    ?._id === "6461cfad3ddb1a01e34b09a4" || // box/กล่อง
                    dataUploadChoice[choiceIndex]?.group_price?.unit_price
                      ?._id === "69bba665ca2c69fc3472fbbe") && ( // แพ็ค
                    <Grid item xs={12}>
                      <WrapperTextfield className="form-input">
                        <TextField
                          label={`ปริมาณสินค้า/${
                            dataUploadChoice[choiceIndex]?.group_price
                              ?.unit_price?.unit_th ?? "หน่วย"
                          }`}
                          variant="outlined"
                          fullWidth
                          InputLabelProps={{
                            shrink: checkNotEmpty(
                              dataUploadChoice[choiceIndex]?.size?.sale_unit,
                            )
                              ? true
                              : false,
                          }}
                          value={dataUploadChoice[choiceIndex].size.sale_unit}
                          onChange={(e) => {
                            if (e.target.value * 0 === 0)
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.size.sale_unit`,
                                e.target.value,
                              );
                          }}
                          onBlur={(e) => {
                            if (e.target.value * 0 === 0)
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.size.sale_unit`,
                                parseFloat(e.target.value) || null,
                              );
                          }}
                          error={
                            !!choiceErrors[
                              `choices[${choiceIndex}].size.sale_unit`
                            ]
                          }
                          helperText={
                            !!choiceErrors[
                              `choices[${choiceIndex}].size.sale_unit`
                            ]
                              ? "โปรดระบุปริมาณต่อหน่วย"
                              : ""
                          }
                        />
                      </WrapperTextfield>
                    </Grid>
                  )}

                  {/* ตร.ม./หน่วย (size.calculate_size) */}
                  {dataUploadChoice[choiceIndex]?.group_price?.unit_price
                    ?._id !== "63c90d859d945fef0df81f61" && // สแลบ
                    dataUploadChoice[choiceIndex]?.group_price?.unit_price
                      ?._id !== "63c90d859d945fef0df81f67" && // ตร.ฟุต
                    dataUploadChoice[choiceIndex]?.group_price?.unit_price
                      ?._id !== "69bba665ca2c69fc3472fbbe" && // แพ็ค
                    dataUploadChoice[choiceIndex]?.group_price?.unit_price
                      ?._id !== "63c90d859d945fef0df81f6a" && // เมตร
                    dataUploadChoice[choiceIndex]?.group_price?.unit_price
                      ?._id !== "63c90d859d945fef0df81f69" && ( // หลา
                      <Grid item xs={12}>
                        <WrapperTextfield className="form-input">
                          <TextField
                            label={`จำนวนตร.ม/${
                              dataUploadChoice[choiceIndex]?.group_price
                                ?.unit_price?.unit_th ?? "หน่วย"
                            }`}
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{
                              shrink: checkNotEmpty(
                                dataUploadChoice[choiceIndex]?.size
                                  ?.calculate_size,
                              )
                                ? true
                                : false,
                            }}
                            value={
                              dataUploadChoice[choiceIndex].size.calculate_size
                            }
                            onChange={(e) => {
                              if (e.target.value * 0 === 0)
                                onChangeUpload(
                                  null,
                                  `choices.${choiceIndex}.size.calculate_size`,
                                  e.target.value,
                                );
                            }}
                            onBlur={(e) => {
                              if (e.target.value * 0 === 0)
                                onChangeUpload(
                                  null,
                                  `choices.${choiceIndex}.size.calculate_size`,
                                  parseFloat(e.target.value) || null,
                                );
                            }}
                            error={
                              !!choiceErrors[
                                `choices[${choiceIndex}].size.calculate_size`
                              ]
                            }
                            helperText={
                              !!choiceErrors[
                                `choices[${choiceIndex}].size.calculate_size`
                              ]
                                ? "โปรดระบุขนาดพื้นที่"
                                : ""
                            }
                          />
                        </WrapperTextfield>
                      </Grid>
                    )}
                </>
              )}
          </Grid>

          <MiddleLine />
        </Grid>

        {/* right */}
        <Grid item xs={5.5}>
          {dataUploadChoice[choiceIndex]?.size?.quantity === "size" ? (
            <>
              <Box
                sx={{
                  mt: 5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <SpanSubTitle>
                  {getLocale() === "th" ? "ขนาด" : "Size"}
                </SpanSubTitle>

                <Tooltip
                  title={
                    "กรุณาระบุขนาดของสินค้าที่ต้องการปรากฏข้อมูลบนหน้าเว็บไซต์ "
                  }
                />
              </Box>

              <Grid
                container
                spacing={0}
                rowSpacing={4}
                columnSpacing={2.5}
                sx={{
                  m: 0,
                  ml: -2.5,
                  ".MuiFormHelperText-root": {
                    position: "absolute",
                    bottom: "-20px",
                    mr: 0,
                  },
                }}
              >
                {dataUploadChoice[choiceIndex]?.group_price?.unit_price?._id !==
                  "63c90d859d945fef0df81f5f" && ( // ตร.ม.
                  <>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        "&.MuiGrid-item": {
                          paddingTop: 1,
                        },
                      }}
                    >
                      <WrapperTextfield className="form-input">
                        <TextField
                          label="กว้าง"
                          variant="outlined"
                          fullWidth
                          InputLabelProps={{
                            shrink: checkNotEmpty(
                              dataUploadChoice[choiceIndex]?.size?.width,
                            )
                              ? true
                              : false,
                          }}
                          value={dataUploadChoice[choiceIndex].size.width}
                          onChange={(e) => {
                            if (e.target.value * 0 === 0)
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.size.width`,
                                e.target.value,
                              );
                          }}
                          onBlur={(e) => {
                            if (e.target.value * 0 === 0)
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.size.width`,
                                parseFloat(e.target.value) || null,
                              );
                          }}
                          error={
                            !!choiceErrors[`choices[${choiceIndex}].size.width`]
                          }
                          helperText={
                            !!choiceErrors[`choices[${choiceIndex}].size.width`]
                              ? "โปรดระบุความกว้าง"
                              : ""
                          }
                        />
                      </WrapperTextfield>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sx={{
                        "&.MuiGrid-item": {
                          paddingTop: 1,
                        },
                      }}
                    >
                      <WrapperTextfield className="form-input">
                        <Autocomplete
                          disablePortal
                          blurOnSelect
                          id="select-width-unit"
                          isOptionEqualToValue={(option, value) =>
                            option?._id === value?._id
                          }
                          options={masterdata?.unitArea_data}
                          value={
                            dataUploadChoice[choiceIndex]?.size?.unit_width
                          }
                          onChange={(e, newValue) => {
                            onChangeUpload(
                              null,
                              `choices.${choiceIndex}.size.unit_width`,
                              newValue,
                            );
                          }}
                          sx={{
                            ".MuiOutlinedInput-input": {
                              borderRadius: 0,
                            },
                          }}
                          getOptionLabel={(option) => {
                            return getLocale() === "th"
                              ? option.unit_th
                              : option.unit_en;
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="หน่วยขนาดสินค้า"
                              error={
                                !!choiceErrors[
                                  `choices[${choiceIndex}].size.unit_width`
                                ]
                              }
                              helperText={
                                !!choiceErrors[
                                  `choices[${choiceIndex}].size.unit_width`
                                ]
                                  ? "โปรดเลือกหน่วย"
                                  : ""
                              }
                            />
                          )}
                        />
                      </WrapperTextfield>
                    </Grid>
                  </>
                )}

                {dataUploadChoice[choiceIndex]?.group_price?.unit_price?._id !==
                  "63c90d859d945fef0df81f5f" && ( // ตร.ม.
                  <>
                    <Grid item xs={6}>
                      <WrapperTextfield className="form-input">
                        <TextField
                          label="ยาว"
                          variant="outlined"
                          fullWidth
                          InputLabelProps={{
                            shrink: checkNotEmpty(
                              dataUploadChoice[choiceIndex]?.size?.height,
                            )
                              ? true
                              : false,
                          }}
                          value={dataUploadChoice[choiceIndex].size.height}
                          onChange={(e) => {
                            if (e.target.value * 0 === 0)
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.size.height`,
                                e.target.value,
                              );
                          }}
                          onBlur={(e) => {
                            if (e.target.value * 0 === 0)
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.size.height`,
                                parseFloat(e.target.value) || null,
                              );
                          }}
                          error={
                            !!choiceErrors[
                              `choices[${choiceIndex}].size.height`
                            ]
                          }
                          helperText={
                            !!choiceErrors[
                              `choices[${choiceIndex}].size.height`
                            ]
                              ? "โปรดระบุความสูง"
                              : ""
                          }
                        />
                      </WrapperTextfield>
                    </Grid>

                    <Grid item xs={6}>
                      <WrapperTextfield className="form-input">
                        <Autocomplete
                          disablePortal
                          blurOnSelect
                          id="select-height-unit"
                          isOptionEqualToValue={(option, value) =>
                            option?._id === value?._id
                          }
                          options={masterdata?.unitArea_data}
                          value={
                            dataUploadChoice[choiceIndex]?.size?.unit_height
                          }
                          onChange={(e, newValue) => {
                            onChangeUpload(
                              null,
                              `choices.${choiceIndex}.size.unit_height`,
                              newValue,
                            );
                          }}
                          sx={{
                            ".MuiOutlinedInput-input": {
                              borderRadius: 0,
                            },
                          }}
                          getOptionLabel={(option) => {
                            return getLocale() === "th"
                              ? option.unit_th
                              : option.unit_en;
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="หน่วยขนาดสินค้า"
                              error={
                                !!choiceErrors[
                                  `choices[${choiceIndex}].size.unit_height`
                                ]
                              }
                              helperText={
                                !!choiceErrors[
                                  `choices[${choiceIndex}].size.unit_height`
                                ]
                                  ? "โปรดเลือกหน่วย"
                                  : ""
                              }
                            />
                          )}
                        />
                      </WrapperTextfield>
                    </Grid>
                  </>
                )}

                <Grid
                  item
                  xs={6}
                  sx={{
                    "&:first-child": {
                      paddingTop: 1,
                    },
                  }}
                >
                  <WrapperTextfield className="form-input">
                    <TextField
                      label="หนา"
                      variant="outlined"
                      fullWidth
                      InputLabelProps={{
                        shrink: checkNotEmpty(
                          dataUploadChoice[choiceIndex]?.size?.thickness,
                        )
                          ? true
                          : false,
                      }}
                      value={dataUploadChoice[choiceIndex].size.thickness}
                      onChange={(e) => {
                        if (e.target.value * 0 === 0)
                          onChangeUpload(
                            null,
                            `choices.${choiceIndex}.size.thickness`,
                            e.target.value,
                          );
                      }}
                      onBlur={(e) => {
                        if (e.target.value * 0 === 0)
                          onChangeUpload(
                            null,
                            `choices.${choiceIndex}.size.thickness`,
                            parseFloat(e.target.value) || null,
                          );
                      }}
                      error={
                        !!choiceErrors[`choices[${choiceIndex}].size.thickness`]
                      }
                      helperText={
                        !!choiceErrors[`choices[${choiceIndex}].size.thickness`]
                          ? "โปรดระบุความหนา"
                          : ""
                      }
                    />
                  </WrapperTextfield>
                </Grid>

                <Grid
                  item
                  xs={6}
                  sx={{
                    "&:nth-child(2)": {
                      paddingTop: 1,
                    },
                  }}
                >
                  <WrapperTextfield className="form-input">
                    <Autocomplete
                      disablePortal
                      blurOnSelect
                      id="select-thickness-unit"
                      isOptionEqualToValue={(option, value) =>
                        option?._id === value?._id
                      }
                      options={masterdata?.unitArea_data}
                      value={
                        dataUploadChoice[choiceIndex]?.size?.unit_thickness
                      }
                      onChange={(e, newValue) => {
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.size.unit_thickness`,
                          newValue,
                        );
                      }}
                      sx={{
                        ".MuiOutlinedInput-input": {
                          borderRadius: 0,
                        },
                      }}
                      getOptionLabel={(option) => {
                        return getLocale() === "th"
                          ? option.unit_th
                          : option.unit_en;
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="หน่วยขนาดสินค้า"
                          error={
                            !!choiceErrors[
                              `choices[${choiceIndex}].size.unit_thickness`
                            ]
                          }
                          helperText={
                            !!choiceErrors[
                              `choices[${choiceIndex}].size.unit_thickness`
                            ]
                              ? "โปรดเลือกหน่วย"
                              : ""
                          }
                        />
                      )}
                    />
                  </WrapperTextfield>
                </Grid>

                <Grid item xs={12}>
                  <WarningText>
                    <ErrorIcon sx={{ color: "var(--gold-color)" }} />

                    <span>
                      กรุณาใส่ข้อมูลที่สำคัญให้ถูกต้องและครบถ้วน
                      เพื่อเป็นประโยชน์ ในการคำนวนราคาสินค้า
                    </span>
                  </WarningText>
                </Grid>
              </Grid>
            </>
          ) : dataUploadChoice[choiceIndex]?.size?.quantity === "capacity" ? (
            <>
              <Box
                sx={{
                  mt: 5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <SpanSubTitle>
                  {getLocale() === "th" ? "ปริมาตร" : "Capacity"}
                </SpanSubTitle>

                <Tooltip
                  title={
                    "กรุณาระบุปริมาตรสินค้าที่ต้องการปรากฏข้อมูลบนหน้าเว็บไซต์ "
                  }
                />
              </Box>

              <Grid
                container
                spacing={0}
                rowSpacing={4}
                columnSpacing={2.5}
                sx={{
                  m: 0,
                  ml: -2.5,
                  ".MuiFormHelperText-root": {
                    position: "absolute",
                    bottom: "-20px",
                    mr: 0,
                  },
                }}
              >
                {dataUploadChoice[choiceIndex]?.group_price?.unit_price?._id !==
                  "63c90d859d945fef0df81f64" && ( // ลิตร
                  <>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        "&.MuiGrid-item": {
                          paddingTop: 1,
                        },
                      }}
                    >
                      <WrapperTextfield className="form-input">
                        <TextField
                          label="ปริมาตร"
                          variant="outlined"
                          fullWidth
                          InputLabelProps={{
                            shrink: checkNotEmpty(
                              dataUploadChoice[choiceIndex]?.size
                                ?.capacity_size,
                            )
                              ? true
                              : false,
                          }}
                          value={
                            dataUploadChoice[choiceIndex].size.capacity_size
                          }
                          onChange={(e) => {
                            if (e.target.value * 0 === 0)
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.size.capacity_size`,
                                e.target.value,
                              );
                          }}
                          onBlur={(e) => {
                            if (e.target.value * 0 === 0)
                              onChangeUpload(
                                null,
                                `choices.${choiceIndex}.size.capacity_size`,
                                parseFloat(e.target.value) || null,
                              );
                          }}
                          error={
                            !!choiceErrors[
                              `choices[${choiceIndex}].size.capacity_size`
                            ]
                          }
                          helperText={
                            !!choiceErrors[
                              `choices[${choiceIndex}].size.capacity_size`
                            ]
                              ? "โปรดระบุปริมาตร"
                              : ""
                          }
                        />
                      </WrapperTextfield>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sx={{
                        "&.MuiGrid-item": {
                          paddingTop: 1,
                        },
                      }}
                    >
                      <WrapperTextfield className="form-input">
                        <Autocomplete
                          disablePortal
                          blurOnSelect
                          id="select-capacity-unit"
                          isOptionEqualToValue={(option, value) =>
                            option?._id === value?._id
                          }
                          options={masterdata?.unitCapacityArea_data}
                          value={
                            dataUploadChoice[choiceIndex]?.size?.unit_capacity
                          }
                          onChange={(e, newValue) => {
                            onChangeUpload(
                              null,
                              `choices.${choiceIndex}.size.unit_capacity`,
                              newValue,
                            );
                          }}
                          sx={{
                            ".MuiOutlinedInput-input": {
                              borderRadius: 0,
                            },
                          }}
                          getOptionLabel={(option) => {
                            return getLocale() === "th"
                              ? option.unit_th
                              : option.unit_en;
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="หน่วยปริมาตรสินค้า"
                              error={
                                !!choiceErrors[
                                  `choices[${choiceIndex}].size.unit_capacity`
                                ]
                              }
                              helperText={
                                !!choiceErrors[
                                  `choices[${choiceIndex}].size.unit_capacity`
                                ]
                                  ? "โปรดระบุหน่วย"
                                  : ""
                              }
                            />
                          )}
                        />
                      </WrapperTextfield>
                    </Grid>
                  </>
                )}

                <Grid
                  item
                  xs={12}
                  sx={{
                    "&:first-child": {
                      paddingTop: 1,
                    },
                  }}
                >
                  <WrapperTextfield className="form-input">
                    <TextField
                      label={`พื้นที่ใช้งาน (ตร.ม./${
                        dataUploadChoice[choiceIndex]?.group_price?.unit_price
                          ?.unit_th ?? "หน่วย"
                      })`}
                      variant="outlined"
                      fullWidth
                      InputLabelProps={{
                        shrink: checkNotEmpty(
                          dataUploadChoice[choiceIndex]?.size?.calculate_size,
                        )
                          ? true
                          : false,
                      }}
                      value={dataUploadChoice[choiceIndex].size.calculate_size}
                      onChange={(e) => {
                        if (e.target.value * 0 === 0)
                          onChangeUpload(
                            null,
                            `choices.${choiceIndex}.size.calculate_size`,
                            e.target.value,
                          );
                      }}
                      onBlur={(e) => {
                        if (e.target.value * 0 === 0)
                          onChangeUpload(
                            null,
                            `choices.${choiceIndex}.size.calculate_size`,
                            parseFloat(e.target.value) || null,
                          );
                      }}
                      error={
                        !!choiceErrors[
                          `choices[${choiceIndex}].size.calculate_size`
                        ]
                      }
                      helperText={
                        !!choiceErrors[
                          `choices[${choiceIndex}].size.calculate_size`
                        ]
                          ? "โปรดระบุหน่วย"
                          : ""
                      }
                    />
                  </WrapperTextfield>
                </Grid>

                <Grid item xs={12}>
                  <WarningText>
                    <ErrorIcon sx={{ color: "var(--gold-color)" }} />

                    <span>
                      กรุณาใส่ข้อมูลที่สำคัญให้ถูกต้องและครบถ้วน
                      เพื่อเป็นประโยชน์ ในการคำนวนราคาสินค้า
                    </span>
                  </WarningText>
                </Grid>
              </Grid>
            </>
          ) : null}
        </Grid>
      </Grid>
    </WrapperContainer>
  );
};

export default UnitPriceGrid;
